/* eslint-disable import/no-mutable-exports, @typescript-eslint/no-unsafe-return, arrow-body-style */

import fallbackContent from '../aemContent/fallbackContent.json';

interface Content {
  [key: string]: any;
}

export let content: Content = {};

export const initContent = () => {
  const data = (window as any)?.clientData;
  content = JSON.parse((window as any)?.clientData?.cmsContent) || fallbackContent.cmsContent;
};
